"use client";

import { useMemo } from "react";
import { useVariableContext } from "../../contexts/VariableContext";

/**
 * Simple hook to get display text with variables replaced
 * Job: Convert template text to display text
 */
export function useVariableDisplay(text: string, selectedClient?: any) {
  const { replaceVariablesInText } = useVariableContext();

  return useMemo(
    () => replaceVariablesInText(text, selectedClient),
    [text, selectedClient, replaceVariablesInText]
  );
}
